import { useBonus } from '.'
import { toast } from '@utils/functions/notificationToast'
import { parseEditBonusPayload } from '../helpers/parseEditBonusPayload'





import { useConsumption } from '@pages/Consumption/context'

import type { AxiosError } from 'axios'
import type {
  ApprovalWorkflowBonusRequestProps,
  GetBonusRequestProps,
  ReleasePreviousBonusRequestProps,
  ReversePreviousBonusRequestProps
} from '@services/api/bonus/types'
import type { EditBonusModalFormProps } from '../components/EditBonusModal/form/types'

import * as apiBonus from '@services/api/bonus'

const reversePreviewBonus = async (payload: ReleasePreviousBonusRequestProps) => {
  const { setIsReversePreviewBonusLoading } = useBonus.getState()

  setIsReversePreviewBonusLoading(true)

  try {
    await apiBonus.reversePreviewBonus(payload)

    toast.success('Prévia revertida com sucesso!')

    getBonus({
      filiCode: payload.filiCode,
      competenceDate: payload.competenceDate
    })

    return true
  } catch (error) {
    toast.error('Não foi possível reverter a prévia. Tente novamente', (error as AxiosError)?.status)

    return false
  } finally {
    setIsReversePreviewBonusLoading(false)
  }
}

const releasePreviewBonus = async (payload: ReleasePreviousBonusRequestProps) => {
  const { setIsReleasePreviewBonusLoading } = useBonus.getState()

  setIsReleasePreviewBonusLoading(true)

  try {
    await apiBonus.releasePreviewBonus(payload)

    toast.success('Prévia liberada com sucesso!')

    getBonus({
      filiCode: payload.filiCode,
      competenceDate: payload.competenceDate
    })

    return true
  } catch (error) {
    toast.error('Não foi possível liberar a prévia. Tente novamente', (error as AxiosError)?.status)

    return false
  } finally {
    setIsReleasePreviewBonusLoading(false)
  }
}

const reverseWorkflowBonus = async (payload: ReversePreviousBonusRequestProps) => {
  const { setIsReverseWorkflowBonusLoading } = useBonus.getState()

  setIsReverseWorkflowBonusLoading(true)

  try {
    await apiBonus.reverseWorkflowBonus(payload)

    toast.success('Bonificação restaurada com sucesso!')

    getBonus({
      filiCode: payload.filiCode,
      competenceDate: payload.competenceDate
    })

    return true
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao restaurar a prévia!'

    toast.error(errorMessage, (error as AxiosError)?.status)

    return false
  } finally {
    setIsReverseWorkflowBonusLoading(false)
  }
}

const approvalWorkflowBonus = async (payload: ApprovalWorkflowBonusRequestProps) => {
  const { setIsApprovalWorkflowBonusLoading } = useBonus.getState()

  setIsApprovalWorkflowBonusLoading(true)

  try {
    await apiBonus.approvalWorkflowBonus(payload)

    toast.success('Prévia de bonificação enviada com sucesso!')

    getBonus({
      filiCode: payload.filiCode,
      competenceDate: payload.competenceDate
    })

    return true
  } catch (error) {
    const errorMessage =
      (error as AxiosError<{ errorMessage: string[] }>)?.response?.data?.errorMessage[0] ||
      'Falha ao enviar a prévia de bonificação!'

    toast.error(errorMessage, (error as AxiosError)?.status)

    return false
  } finally {
    setIsApprovalWorkflowBonusLoading(false)
  }
}

const editBonus = async (formData: EditBonusModalFormProps) => {
  const { filiCode: code, startPeriod: period } = formData
  const payload = parseEditBonusPayload(formData)
  
  const { setIsEditBonusLoading } = useBonus.getState()
  const { getBigNumbersConsumption } = useConsumption.getState()

  setIsEditBonusLoading(true)

  try {
    const sideEffectPayload = { filiCode: code!, competenceDate: period! }

    await apiBonus.editBonus(payload)
    toast.success('A bonificação foi atualizada com sucesso!')

    await Promise.all([
      getBonus(sideEffectPayload),
      getBigNumbersConsumption(sideEffectPayload)
    ])

    return true
  } catch (error) {
    toast.error('Falha ao atualizar a bonificação!', (error as AxiosError)?.status)
    return false
  } finally {
    setIsEditBonusLoading(false)
  }
}

const getBonus = async (payload: GetBonusRequestProps) => {
  const { setBonusData, setIsBonusLoading } = useBonus.getState()

  setIsBonusLoading(true)

  try {
    const data = await apiBonus.getBonus(payload)

    setBonusData(data)
  } catch (error) {
    toast.error('Falha ao buscar os bonus!', (error as AxiosError)?.status)
  } finally {
    setIsBonusLoading(false)
  }
}

export { getBonus, editBonus, reverseWorkflowBonus, approvalWorkflowBonus, reversePreviewBonus, releasePreviewBonus }
